import styled from "@emotion/styled"
import type { PButtonProps } from "@porsche-design-system/components-react"
import { PButton } from "@porsche-design-system/components-react"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren } from "react"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"
import { ContainerHeader, navigationMessages, Tooltip } from "src/components"

const messages = defineMessages({
	addVehicle: {
		defaultMessage: "Add vehicle",
		id: "inventorylist.addVehicle",
	},
	excelExportButton: {
		defaultMessage: "Export Vehicles",
		id: "inventorylist.excelButton",
	},
	openInFinder: {
		defaultMessage: "Open listings in customer application",
		id: "inventorylist.openListingsInFinder",
	},
})

interface HeaderProps extends PropsWithChildren {
	addVehicleDisabledHint?: string
	isExcelLoading: boolean
	onAddVehicleClick?: () => void
	onExcelExportClick: () => void
}

export const Header = ({
	addVehicleDisabledHint,
	children,
	isExcelLoading,
	onAddVehicleClick,
	onExcelExportClick,
}: HeaderProps) => {
	const { formatMessage } = useIntl()

	const buttonProps: PButtonProps = {
		hideLabel: { base: true, s: false },
		type: "button",
	}

	return (
		<StyledContainerHeader
			title={formatMessage(navigationMessages.inventoryList)}
			actions={
				<>
					{onAddVehicleClick && (
						<Tooltip content={addVehicleDisabledHint}>
							<PButton
								{...buttonProps}
								icon="plus"
								disabled={!!addVehicleDisabledHint}
								data-testid="add-vehicle-button"
								onClick={onAddVehicleClick}
							>
								<FormattedMessage {...messages.addVehicle} />
							</PButton>
						</Tooltip>
					)}

					<PButton
						{...buttonProps}
						type="button"
						variant="secondary"
						icon="download"
						loading={isExcelLoading}
						onClick={onExcelExportClick}
					>
						<FormattedMessage {...messages.excelExportButton} />
					</PButton>
				</>
			}
		>
			{children}
		</StyledContainerHeader>
	)
}

const StyledContainerHeader = styled(ContainerHeader)`
	row-gap: ${spacingStaticSm};
`
